module.exports = __webpack_public_path__ + "img/midfi-1.44511830.png";